export const checkoutQueryKeys = {
  validateTransactionKey: (chargeId: string) =>
    [chargeId, 'validate-transaction'] as const,
  getRecurrencePossibility: (id: string) =>
    [id, 'recurrence-possibility'] as const,
}
